import { UserConfig } from '../types';

const createStyleNodes = (itemName: string) => ({
  item: itemName,
  children: [
    {
      item: "Colori",
      sfondo: [{ fieldType: "Color", userValue: "#ffffff", defaultValue: "#ffffff" }],
      voci: [{ fieldType: "Color", userValue: "#111827", defaultValue: "#111827" }],
      mouseover: [{ fieldType: "Color", userValue: "#f3f4f6", defaultValue: "#f3f4f6" }],
      onclick: [{ fieldType: "Color", userValue: "#e5e7eb", defaultValue: "#e5e7eb" }],
      selected: [{ fieldType: "Color", userValue: "#3b82f6", defaultValue: "#3b82f6" }],
      unselected: [{ fieldType: "Color", userValue: "#6b7280", defaultValue: "#6b7280" }]
    },
    {
      item: "Dimensioni",
      margini: [{ fieldType: "NumberStepper", userValue: "4px", defaultValue: "4px" }],
      padding: [{ fieldType: "NumberStepper", userValue: "2px", defaultValue: "2px" }]
    },
    {
      item: "Font",
      tipo_carattere: [{ fieldType: "Select", userValue: "Inter", defaultValue: "Inter" }],
      dimensione: [{ fieldType: "NumberStepper", userValue: "14px", defaultValue: "14px" }],
      formato: [{ fieldType: "Select", userValue: "normale", defaultValue: "normale" }]
    }
  ]
});

// Rilevamento sistema operativo per cartella di download default
const getOSDefaultDownload = () => {
  const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent.toLowerCase() : '';
  if (userAgent.includes('win')) return 'C:\\Download';
  if (userAgent.includes('mac')) return '/Users/download';
  return '/home/download';
};

export const DEFAULT_CONFIG: UserConfig = {
  items: [
    {
      item: "Aspetto",
      children: [
        {
          item: "Menù",
          children: [
            {
              item: "Sfondo",
              sfondo_generale: [{ fieldType: "Color", userValue: "#ffffff", defaultValue: "#ffffff" }]
            },
            {
              item: "Bordo",
              bordo_tipo: [{ fieldType: "Select", userValue: "solid", defaultValue: "solid" }],
              bordo_spessore: [{ fieldType: "NumberStepper", userValue: "1px", defaultValue: "1px" }],
              bordo_colore: [{ fieldType: "Color", userValue: "#e5e7eb", defaultValue: "#e5e7eb" }]
            },
            {
              item: "Icone",
              colore_icona: [{ fieldType: "Color", userValue: "#3b82f6", defaultValue: "#3b82f6" }],
              sfondo_icona: [{ fieldType: "Color", userValue: "#eff6ff", defaultValue: "#eff6ff" }],
              bordo_icona_colore: [{ fieldType: "Color", userValue: "#ffffff", defaultValue: "#ffffff" }],
              bordo_icona_spessore: [{ fieldType: "NumberStepper", userValue: "1px", defaultValue: "1px" }]
            },
            {
              item: "Sezioni",
              desktop_larghezza: [{ fieldType: "NumberStepper", userValue: "200px", defaultValue: "200px" }],
              desktop_altezza: [{ fieldType: "NumberStepper", userValue: "110px", defaultValue: "110px" }],
              desktop_sfondo: [{ fieldType: "Color", userValue: "#ffffff", defaultValue: "#ffffff" }],
              desktop_font_titolo: [{ fieldType: "Select", userValue: "Inter", defaultValue: "Inter" }],
              desktop_colore_titolo: [{ fieldType: "Color", userValue: "#111827", defaultValue: "#111827" }],
              desktop_stile_titolo: [{ fieldType: "Select", userValue: "bold", defaultValue: "bold" }],
              
              tablet_larghezza: [{ fieldType: "NumberStepper", userValue: "180px", defaultValue: "180px" }],
              tablet_altezza: [{ fieldType: "NumberStepper", userValue: "100px", defaultValue: "100px" }],
              tablet_sfondo: [{ fieldType: "Color", userValue: "#ffffff", defaultValue: "#ffffff" }],
              tablet_font_titolo: [{ fieldType: "Select", userValue: "Inter", defaultValue: "Inter" }],
              tablet_colore_titolo: [{ fieldType: "Color", userValue: "#111827", defaultValue: "#111827" }],
              tablet_stile_titolo: [{ fieldType: "Select", userValue: "bold", defaultValue: "bold" }],
              
              mobile_larghezza: [{ fieldType: "NumberStepper", userValue: "100%", defaultValue: "100%" }],
              mobile_altezza: [{ fieldType: "NumberStepper", userValue: "80px", defaultValue: "80px" }],
              mobile_sfondo: [{ fieldType: "Color", userValue: "#ffffff", defaultValue: "#ffffff" }],
              mobile_font_titolo: [{ fieldType: "Select", userValue: "Inter", defaultValue: "Inter" }],
              mobile_colore_titolo: [{ fieldType: "Color", userValue: "#111827", defaultValue: "#111827" }],
              mobile_stile_titolo: [{ fieldType: "Select", userValue: "bold", defaultValue: "bold" }],

              bordo_spessore: [{ fieldType: "NumberStepper", userValue: "1px", defaultValue: "1px" }],
              bordo_colore: [{ fieldType: "Color", userValue: "#e5e7eb", defaultValue: "#e5e7eb" }]
            },
            createStyleNodes("Colori").children[0],
            createStyleNodes("Dimensioni").children[1],
            createStyleNodes("Font").children[2]
          ]
        }
      ]
    },
    {
      item: "File System",
      children: [
        {
          item: "Download",
          cartella_download: [{ fieldType: "Text", userValue: getOSDefaultDownload(), defaultValue: getOSDefaultDownload() }]
        },
        {
          item: "Upload",
          cartella_upload: [{ fieldType: "Text", userValue: "/tmp/upload", defaultValue: "/tmp/upload" }]
        }
      ]
    },
    {
      item: "Google Workspace Hub",
      children: [
        {
          item: "Integrazione",
          attiva: [{ fieldType: "Boolean", userValue: false, defaultValue: false }]
        }
      ]
    }
  ]
};
